import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';

import { User } from 'lucide-react';

import { getUserData } from '../../store/misc.slice';

import { useSignout } from '../../hooks/auth-cax';

import { LogoPackageHoriz } from './LogoPackage';
import { OutsideAlerter } from '../utilities/OutsideAlerter';

export const Navbar = () => {
    const navigate = useNavigate();

    const userData = useSelector(getUserData());

    const [isDropdownOpen, setIsDropdownOpen] = useState(false);

    const { mutate: signout } = useSignout();

    const goToPage = (route: string) => {
        setIsDropdownOpen(false);
        navigate(route);
    };

    return (
        <div className='navbar'>
            <div className='navbar__content'>
                <Link to="/"><LogoPackageHoriz /></Link>
                <div className="navbar__right">
                    {!!userData &&
                        <div className='navbar__user_data'>
                            <button className='navbar__user_data__main_btn' onClick={() => setIsDropdownOpen(!isDropdownOpen)}>
                                <p className='text-sm text-medium'>{userData.email[0].toUpperCase()}</p>
                            </button>
                            <OutsideAlerter isActive={isDropdownOpen} callback={() => setIsDropdownOpen(false)}>
                                <div className={`navbar__user_data__dropdown ${isDropdownOpen ? 'navbar__user_data__dropdown--open' : ''}`}>
                                    <div className='navbar__user_data__dropdown__menu'>
                                        <button onClick={() => goToPage('/')}>Dashboard</button>
                                        <button onClick={() => goToPage('/sub-clients')}>Sub Clients</button>
                                        <button onClick={() => goToPage('/cohorts')}>Cohorts</button>
                                        <button onClick={() => goToPage('/participants')}>Participants</button>
                                        <button onClick={() => goToPage('/bulk-entitlements')} disabled>Distribute Entitlements</button>
                                        <button onClick={() => goToPage('/settings')}>Settings</button>
                                        <button onClick={() => signout()}>Log out</button>
                                    </div>
                                </div>
                            </OutsideAlerter>
                        </div>
                    }
                    {!userData &&
                        <button
                            className='navbar__sign_in_btn'
                            onClick={() => navigate('/auth')}
                        >
                            <div>
                                <User />
                            </div>
                            <p>Sign In</p>
                        </button>
                    }
                </div>
            </div>
        </div>
    );
};